module.exports = __webpack_public_path__ + "static/img/oil-extractor_256.f4a28bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oil-extractor_256.png
// module id = r/D0
// module chunks = 0